export const queryKeys = {
  characters: {
    all: ['characters'] as const,
    detail: (id: string) => ['characters', id] as const,
    levelUpPlan: (id: string) => ['characters', id, 'level-up-plan'] as const,
  },
  campaigns: {
    all: ['campaigns'] as const,
    detail: (id: string) => ['campaigns', id] as const,
  },
  invites: {
    all: ['invites'] as const,
  },
  campaignInventory: {
    sync: (campaignId: string) => ['campaign-inventory', campaignId] as const,
    presets: (campaignId: string) => ['campaign-inventory', campaignId, 'presets'] as const,
  },
  gameData: {
    deities: (gs: string) => ['game-data', 'deities', gs] as const,
    ancestries: (gs: string) => ['game-data', 'ancestries', gs] as const,
    backgrounds: (gs: string) => ['game-data', 'backgrounds', gs] as const,
    classes: (gs: string) => ['game-data', 'classes', gs] as const,
    classProgression: (id: string) => ['game-data', 'class-progression', id] as const,
    classOptions: (classId: string) => ['game-data', 'class-options', classId] as const,
    feats: (filters: Record<string, unknown>) => ['game-data', 'feats', filters] as const,
    spells: (filters: Record<string, unknown>) => ['game-data', 'spells', filters] as const,
    featsResolve: (ids: string[]) => ['game-data', 'feats-resolve', ids] as const,
    spellsResolve: (names: string[], gs: string) => ['game-data', 'spells-resolve', names, gs] as const,
    battleForms: (gs: string, source?: string) => ['game-data', 'battle-forms', gs, source] as const,
  },
} as const;
